module.exports = __webpack_public_path__ + "img/nec.6e509383.png";